import { Breadcrumbs, Layout as LayoutMagik, Menu } from "@inmagik/magik-ui"
import classNames from "classnames"
import { useAuth } from "../auth"
import { Link } from "react-router-dom"

export default function Layout({ children, scrollable = false }: { children: React.ReactNode; scrollable?: boolean }) {
  const { performLogout } = useAuth()
  return (
    <LayoutMagik className="temp-layout-fix">
      <LayoutMagik.Header className="px-4 py-2">
        <LayoutMagik.Header.Left className="d-flex align-items-center">
          <Link
            to="/"
            style={{
              textDecoration: "none",
            }}
          >
            <div
              style={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                color: "var(--primary)",
              }}
            >
              Cabiria Admin
            </div>
          </Link>
        </LayoutMagik.Header.Left>
        <LayoutMagik.Header.Center className="d-flex align-items-center">
          <Breadcrumbs />
        </LayoutMagik.Header.Center>
        <LayoutMagik.Header.Right>
          <Menu.Item
            title="Logout"
            icon="logout"
            onClick={() => {
              performLogout()
            }}
          />
        </LayoutMagik.Header.Right>
      </LayoutMagik.Header>
      <LayoutMagik.SidebarLeft className="py-5 px-4">
        <Menu className="h-100">
          <Menu.Item title="Dashboard" link="/" />
          <Menu.Item title="Testi" link="/text-contents/text-contents" />
          <Menu.Item title="Gruppi di ricerca" link="/group-of-researches/group-of-researches" />
          <Menu.Item title="Temi" link="/themes/themes" />
          <Menu.Item title="Percorsi" link="/paths/paths" />
          <Menu.Item title="Entità nominate" link="/named-entities/named-entities" />
          <Menu.Item title="Media" link="/media/media" />
          <Menu.Divider />
          <Menu.FillEmptySpace />
          <Menu.Item title="Utenti" link="/utenti/utenti" />
          <Menu.Item title="Profilo" link="/profilo" />
        </Menu>
      </LayoutMagik.SidebarLeft>
      {/* <Layout.SidebarRight>Right</Layout.SidebarRight> */}
      <LayoutMagik.Main
        className={classNames("w-100 h-100 px-6 py-4", {
          "overflow-auto": scrollable,
        })}
      >
        {children}
      </LayoutMagik.Main>
    </LayoutMagik>
  )
}
